import { ShieldCheck, Users } from 'lucide-react';

export function VerifiedBadge({ size = 'sm', className = '' }) {
  const cls = size === 'lg' ? 'text-sm px-3 py-1' : 'text-[10px] px-2 py-0.5';
  return (
    <span
      data-testid="verified-badge"
      className={`inline-flex items-center gap-1 ${cls} bg-brand-blue text-brand-blue-foreground font-semibold uppercase tracking-wider rounded-sm ${className}`}
    >
      <ShieldCheck className="h-3 w-3" /> Verified
    </span>
  );
}

export function OfficialBadge({ className = '' }) {
  return (
    <span
      data-testid="official-badge"
      className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 bg-foreground text-background font-semibold uppercase tracking-wider rounded-sm border-l-2 border-primary ${className}`}
    >
      <ShieldCheck className="h-3 w-3" /> Official
    </span>
  );
}

export function CommunityBadge({ className = '' }) {
  return (
    <span
      data-testid="community-badge"
      className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 bg-secondary text-secondary-foreground border border-border font-semibold uppercase tracking-wider rounded-sm ${className}`}
    >
      <Users className="h-3 w-3" /> Community
    </span>
  );
}
